import { render } from "./SuccessApply.vue?vue&type=template&id=35422a62"
import script from "./SuccessApply.vue?vue&type=script&lang=js"
export * from "./SuccessApply.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__